import { Box, Typography, Button, Flex } from "@jewlr/storybook/core"
import { Link } from "react-router-dom"
import styled from "styled-components"

export const CheckoutBtn = styled(Button).attrs((props) => ({
  bg: props.theme.colors.guaranteed,
  color: "white",
  fontSize: "18px",
  fontWeight: { tablet: "300" },
  letterSpacing: "1.5px",
  width: { _: "100%", tablet: "80%" },
  ...props.theme.order.checkoutBtn,
  ...props,
}))``
export const Text = styled(Typography).attrs({
  display: "block",
  fontSize: "16px",
  lineHeight: "24px",
  textAlign: { _: "center", tablet: "left" },
})``

export const Title = styled(Typography).attrs({
  as: "span",
  display: "inline-block",
  fontWeight: "bold",
  pr: { tablet: "60px" },
})``
export const ErrorModalContent = () => {
  return (
    <Flex flexDirection="column" px={5} textAlign="center">
      <Box flex="1" mb={4} mt={2}>
        <Typography lineHeight={2}>
          There was an issue adding warranties to your order. Please contact
          customer service at
          <Typography
            as="a"
            color="primary"
            href={`tel:+${sl.config.customer_service_toll_free} `}
          >
            {sl.config.customer_service_toll_free}
          </Typography>{" "}
          or try again in a little while. You can always send us an email to{" "}
          <Typography
            as="a"
            color="primary"
            href={`mailto:${sl.config.customer_service_email}`}
          >
            {sl.config.customer_service_email}.
          </Typography>
        </Typography>
      </Box>
      <Box flex="1">
        <CheckoutBtn
          as={Link}
          bg="primary"
          data-lc="components"
          to="/"
          width={{ _: "100%", tablet: "50%" }}
        >
          Return to Jewlr
        </CheckoutBtn>
      </Box>
    </Flex>
  )
}
